import * as type from './type';
export default {
    [type.LISTRN_RN_CALLBACK](state, rnCallbackFlag) {
        state.rnCallbackFlag = rnCallbackFlag;
    },
    [type.SET_HOT_SALES](state, hotSaleList) {
        state.hotSaleList = hotSaleList;
    },
    //设置iOS完整手机号
    [type.SET_IOS_DECODE_PHONE](state, iosDecodePhone) {
        state.iosDecodePhone = iosDecodePhone;
    },
    //设置app当前版本号
    [type.SET_APP_VERSION](state, appVersion) {
        state.appVersion = appVersion;
    },
    //设置app当前版本号Info
    [type.SET_APP_VER_INFO](state, appVerInfo) {
        state.appVerInfo = appVerInfo;
    },
    //设置用户信息
    [type.SET_USER_INFO](state, userInfo) {
        state.userInfo = userInfo;
    },
    //设置用户类型值
    [type.SET_USER_TYPE](state, tpUser) {
        state.tpUser = tpUser;
    },
    //设置用户状态
    [type.SET_USER_STATE](state, userState) {
        state.userState = userState;
    },
    //设置用户身份值
    [type.SET_USER_IDENTITY](state, userIdentity) {
        state.userIdentity = userIdentity;
    },
    //设置用户邮箱
    [type.SET_USER_MAIL](state, userMail) {
        state.userMail = userMail;
    },
    //设置当前页面是否是一级页面
    [type.SET_IS_FIRST_LEVEL_PAGE](state, isFirstLevelPage) {
        state.isFirstLevelPage = isFirstLevelPage;
    },
    //设置app是否是暗黑模式
    [type.SET_DARK_MODE](state, darkmode) {
        state.darkmode = darkmode;
    },
    //设置是否隐藏返回头
    [type.SET_HIDE_HEADER](state, isHideHeader) {
        state.isHideHeader = isHideHeader;
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js